export const scepterOfTheWarden = `
{{My child, the secret of power is the power of secrets. Invade. Infect. Impress.[[x,100,x]]}}
{{Win[[x,100,100]]}}
{{Let me bestow upon you the[[x,x,x]]}} {{Mask of Althan[[x,100,100]]<<Mask of Althan>>[[x,100,100]]}}
`;
